const downloadFileModal = () => {
  const menuPoints = document.querySelectorAll('.file-card__menu-points')
  const downloadBlocks = document.querySelectorAll('.file-download')
  const closeIcons = document.querySelectorAll('.close')

  downloadBlocks &&
    downloadBlocks.forEach((item, index) => {
      item.dataset.downloadId = index
    })

  menuPoints &&
    menuPoints.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (downloadBlocks[index].dataset.downloadId == index) {
          downloadBlocks[index].classList.toggle('invisible')
        }
      })
    })

  closeIcons &&
    closeIcons.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (downloadBlocks[index].dataset.downloadId == index) {
          downloadBlocks[index].classList.toggle('invisible')
        }
      })
    })
}

document.addEventListener('DOMContentLoaded', downloadFileModal)
